/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProgramaParametrosModelDto } from '../../models/programa-parametros-model-dto';

export interface ProgramasControllerObtenerPrograma$Params {

/**
 * UUID del programa a obtener
 */
  uuidPrograma: string;
}

export function programasControllerObtenerPrograma(http: HttpClient, rootUrl: string, params: ProgramasControllerObtenerPrograma$Params, context?: HttpContext): Observable<StrictHttpResponse<ProgramaParametrosModelDto>> {
  const rb = new RequestBuilder(rootUrl, programasControllerObtenerPrograma.PATH, 'get');
  if (params) {
    rb.path('uuidPrograma', params.uuidPrograma, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProgramaParametrosModelDto>;
    })
  );
}

programasControllerObtenerPrograma.PATH = '/api/programas/detalle-programa/{uuidPrograma}';
